import axiosInstance from './axiosInstance';

export const getAssetType = async () => {
  try {
    const response = await axiosInstance.get('/asset-type');
    return response.data;
  } catch (error) {
    console.error('Error fetching asset-type:', error.response?.data || error);
    throw error;
  }
};

export const getAssetTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`/asset-type/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching asset-type:', error.response?.data || error);
    throw error;
  }
};

export const getAssetTypeByName = async (name) => {
  try {
    const response = await axiosInstance.get(
      `/asset-type/check/${encodeURIComponent(name)}`,
      {      },
    );
    return response.data;
  } catch (error) {
    console.error('Error checking asset-type:', error.response?.data || error);
    throw error;
  }
};

export const createAssetType = async (assetTypeData) => {
  try {
    const response = await axiosInstance.post('/asset-type', assetTypeData);
    return response.data;
  } catch (error) {
    console.error('Error creating asset-type:', error.response?.data || error);
    throw error;
  }
};

export const updateAssetType = async (id, assetTypeData) => {
  try {
    const response = await axiosInstance.put(`/asset-type/${id}`, assetTypeData);
    return response.data;
  } catch (error) {
    console.error('Error updating asset-type:', error.response?.data || error);
    throw error;
  }
};

export const deleteAssetType = async (id) => {
  try {
    const response = await axiosInstance.delete(`/asset-type/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting asset-type:', error.response?.data || error);
    throw error;
  }
};
